import { useRouter } from 'next/router'
import { NextSeo } from 'next-seo'
import React, { useEffect } from 'react'
import { useUserByUsername } from 'services'
import { useLoginState } from 'state'
import { logger } from 'utils'

import { NotFoundPage } from '../../Misc'
import BasicDetailsV2 from '../components/BasicDetailsV2'
import Certificates from '../components/Certificates'
import DevsnestData from '../components/DevsnestData'
import ExternalData from '../components/ExternalData'

const UserProfileV2 = () => {
  const router = useRouter()
  const { query, pathname } = router
  const { user: loggedInUser } = useLoginState()

  const username =
    typeof query.username === 'string' ? query.username : loggedInUser?.username
  const isCurrentUser = username === loggedInUser?.username

  // if we are at path /u/username take username from url
  // or else use current user's username
  const {
    data: user,
    isError,
    isLoading
  } = useUserByUsername(username || loggedInUser?.username || '')

  logger('userByUsername', { username, user, query })

  useEffect(() => {
    if (loggedInUser) {
      if (pathname === '/profile' && !query.code) {
        router.push(`/u/${username}`)
      }
    }
  }, [loggedInUser, pathname, query.code, router, username])

  // loading the details
  if (!user || isLoading) {
    return (
      <div className="animate-spin h-24 w-24 rounded-full border-b border-white m-auto" />
    )
  }

  // if there is an error the user might not have been found or doesn't have username
  if (isError || !username) {
    return <NotFoundPage />
  }

  return (
    <div className="flex">
      <NextSeo title={`${username} | Devsnest`} />

      <div className="flex flex-col md:flex-row w-full gap-4 my-6">
        <section className="flex md:w-[30%] w-fullx">
          <BasicDetailsV2 user={user} isCurrentUser={isCurrentUser} />
        </section>
        <section className="md:w-[70%] w-full flex flex-col">
          <DevsnestData user={user} />
          <ExternalData user={user} isCurrentUser={isCurrentUser} />
          {/* Certificates  */}
          <div className="flex w-full flex-col bg-[#1A1A1E] p-6 gap-4 rounded-sm">
            <Certificates user_id={user.id} />
          </div>
        </section>
      </div>
    </div>
  )
}

export default UserProfileV2

UserProfileV2.layout = {
  navProps: {
    type: 'product'
  }
}
